import { isFeatureEnabled } from 'owa-feature-flags';
import { folderRestriction } from './folderRestriction';

/**
 * When 'notes-folder-view' flight is enabled, some commands need to be hidden in 'Notes' folder.
 * When the flight is disabled, the commands should rely on existing logic, hence returning TRUE.
 */
const notesFolderRestriction = () => () => {
    if (isFeatureEnabled('notes-folder-view')) {
        return folderRestriction(['notes'], true)();
    } else {
        return true;
    }
};

export default notesFolderRestriction;
